import unauthorizedRedirect from "~/components/utilities/unauthorizedRedirect";

const commentReport = async function commentReport({
  reasonId,
  reportContentId,
  captchaResponse,
}) {
  const params = { reasonId, commentId: reportContentId, captchaResponse };

  try {
    await this.$store.dispatch("reportComment", params);
  } catch (error) {
    if (error?.status.find((err) => err.message === "Access Denied")) {
      unauthorizedRedirect(
        this.$router.replace,
        this.$isServer,
        this.$config,
        undefined
      );
    } else {
      throw error;
    }
  }
};

export default commentReport;
